export default {
  namespaced: true,
  state: {
    menuItems: null,
    rootAPIEnv1: '',
    rootAPIEnv2: '',
    rootAPI: null
  },
  mutations: {
    LOAD_MENU_ITEMS: function (state, menuItems) {
      // console.log(menuItems)
      if (menuItems.rootAPI) {
        state.menuItems = menuItems.items
        state.rootAPIEnv1 = menuItems.rootAPIEnv1
        state.rootAPIEnv2 = menuItems.rootAPIEnv2
        state.rootAPI = menuItems.rootAPI
      } else {
        state.menuItems = menuItems
        state.rootAPIEnv1 = menuItems[0].rootAPIEnv1
        state.rootAPIEnv2 = menuItems[0].rootAPIEnv2
        state.rootAPI = menuItems[0].rootAPI
      }
    }
  },
  actions: {
    loadMenuItems (context, payload) {
      // console.log(payload)
      // console.log(process.env.VUE_APP_ROOT_API)
      let itemsToCommit
      if (payload.items.find(item => item.key === payload.extraMenuSelected)) {
        itemsToCommit = payload.items.find(item => item.key === payload.extraMenuSelected)
        // console.log(payload.items.find(item => item.key === payload.extraMenuSelected).rootAPI)
      } else {
        itemsToCommit = payload.items
        // console.log(payload)
        // itemsToCommit.rootAPI = process.env.VUE_APP_ROOT_API
        // console.log(process.env.VUE_APP_ROOT_API)
      }
      context.commit('LOAD_MENU_ITEMS', itemsToCommit)
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/main-menu.js